var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClassCode = function SvgClassCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.24 13.742 2.032-6.093a.765.765 0 0 1 1.451 0l2.032 6.093m-4.78-2.206H9.02M16.843 12.334v2.962h2.289a1.481 1.481 0 1 0 0-2.962h-2.29ZM16.843 15.304v3.5H19.4a1.75 1.75 0 1 0 0-3.5h-2.558Z",
    stroke: "#EDEDF9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.996 2.846C.996 1.826 1.823 1 2.843 1h8.31c1.02 0 1.846.827 1.846 1.846v15.167c0 1.02-.826 1.846-1.846 1.846h-8.31a1.846 1.846 0 0 1-1.847-1.846V2.846Z",
    stroke: "#EDEDF9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.154V7.987c0-1.02-.826-1.846-1.846-1.846h-8.31c-1.02 0-1.847.827-1.847 1.846v15.167c0 1.02.827 1.846 1.847 1.846h8.31c1.02 0 1.846-.827 1.846-1.846Z",
    stroke: "#EDEDF9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgClassCode;